<app-modal
  [isOpen]="isOpen"
  (close)="onClose()"
  className="max-w-4xl mx-4 sm:mx-6"
>
  @if (deal) {
    <div class="p-6 sm:p-8">
      <!-- Header with Oportunidad Name and Amount -->
      <div class="flex items-start justify-between gap-6 mb-8">
        <!-- Oportunidad Info -->
        <div class="flex-1 min-w-0">
          <div class="flex items-start justify-between gap-3 mb-2">
            <h2 class="text-2xl font-bold text-gray-900 dark:text-white">
              {{ deal.name }}
            </h2>
            <app-quick-actions-menu
              label="Acciones"
              align="right"
              [dealId]="deal.id"
              [dealName]="deal.name"
              [companyId]="deal.idCompany"
              [companyName]="deal.companyName"
              [leadId]="deal.idLead"
              (actionTriggered)="onClose()"
            >
            </app-quick-actions-menu>
          </div>
          @if (deal.description) {
            <p class="text-base text-gray-600 dark:text-gray-400 mb-3">
              {{ deal.description }}
            </p>
          }
          <!-- Amounts Display -->
          <div class="flex items-start gap-4 flex-wrap">
            <div class="flex-1 min-w-0">
              <!-- Currency Badge -->
              <div class="mb-2">
                <span
                  class="inline-flex items-center px-2 py-1 text-xs font-medium rounded bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300"
                >
                  {{ deal.prefix }}
                </span>
              </div>
              @if (deal.amount) {
                <div class="mb-2">
                  <p class="text-xs text-gray-500 dark:text-gray-400">Valor</p>
                  <p
                    class="text-2xl font-bold text-brand-600 dark:text-brand-400"
                  >
                    {{ formatCurrency(deal.amount) }}
                  </p>
                </div>
              }
            </div>
          </div>
          <div class="flex justify-between gap-2">
            <!-- IZQUIERDA -->
            <app-badge [color]="dealStatusBadgeColor">
              {{ isClosed ? 'Cerrado' : 'Activo' }}
            </app-badge>

            @if (loadingUsers) {
              <div
                class="animate-spin rounded-full h-4 w-4 border-b-2 border-brand-500"
              ></div>
            } @else if (ownerUser) {
              <span class="text-sm font-medium text-gray-900 dark:text-white">
                <span
                  class="text-sm font-medium text-gray-700 dark:text-gray-300"
                >
                  Responsable:
                </span>
                {{ ownerUser.fullname }} {{ ownerUser.lastname }}
              </span>
            } @else {
              <span class="text-sm text-gray-400 dark:text-gray-500 italic">
                Sin información
              </span>
            }
          </div>
        </div>
      </div>

      <!-- Tab navigation -->
      <div class="border-b border-gray-200 dark:border-gray-700 mb-6">
        <nav class="-mb-px flex gap-1">
          <button
            (click)="onTabChange('info')"
            class="whitespace-nowrap px-4 py-2.5 text-sm font-medium border-b-2 transition-colors"
            [class.border-brand-500]="activeTab === 'info'"
            [class.text-brand-600]="activeTab === 'info'"
            [class.dark:text-brand-400]="activeTab === 'info'"
            [class.border-transparent]="activeTab !== 'info'"
            [class.text-gray-500]="activeTab !== 'info'"
            [class.hover:text-gray-700]="activeTab !== 'info'"
            [class.dark:text-gray-400]="activeTab !== 'info'"
          >
            Información
          </button>
          <button
            (click)="onTabChange('quotes')"
            class="whitespace-nowrap px-4 py-2.5 text-sm font-medium border-b-2 transition-colors"
            [class.border-brand-500]="activeTab === 'quotes'"
            [class.text-brand-600]="activeTab === 'quotes'"
            [class.dark:text-brand-400]="activeTab === 'quotes'"
            [class.border-transparent]="activeTab !== 'quotes'"
            [class.text-gray-500]="activeTab !== 'quotes'"
            [class.hover:text-gray-700]="activeTab !== 'quotes'"
            [class.dark:text-gray-400]="activeTab !== 'quotes'"
          >
            Cotizaciones
          </button>
          <button
            (click)="onTabChange('timeline')"
            class="whitespace-nowrap px-4 py-2.5 text-sm font-medium border-b-2 transition-colors"
            [class.border-brand-500]="activeTab === 'timeline'"
            [class.text-brand-600]="activeTab === 'timeline'"
            [class.dark:text-brand-400]="activeTab === 'timeline'"
            [class.border-transparent]="activeTab !== 'timeline'"
            [class.text-gray-500]="activeTab !== 'timeline'"
            [class.hover:text-gray-700]="activeTab !== 'timeline'"
            [class.dark:text-gray-400]="activeTab !== 'timeline'"
          >
            Línea de Tiempo
          </button>
          <button
            (click)="onTabChange('automatizaciones')"
            class="whitespace-nowrap px-4 py-2.5 text-sm font-medium border-b-2 transition-colors"
            [class.border-brand-500]="activeTab === 'automatizaciones'"
            [class.text-brand-600]="activeTab === 'automatizaciones'"
            [class.dark:text-brand-400]="activeTab === 'automatizaciones'"
            [class.border-transparent]="activeTab !== 'automatizaciones'"
            [class.text-gray-500]="activeTab !== 'automatizaciones'"
            [class.hover:text-gray-700]="activeTab !== 'automatizaciones'"
            [class.dark:text-gray-400]="activeTab !== 'automatizaciones'"
          >
            Automatizaciones
          </button>
        </nav>
      </div>

      @if (activeTab === 'info') {
        <!-- Oportunidad Information Grid -->
        <div class="space-y-6">
          <!-- Main Oportunidad Details Section -->
          <div>
            <h3
              class="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-3"
            >
              Detalles del Negocio
            </h3>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <!-- Oportunidad Cycle -->
              <div class="flex items-start gap-3">
                <div class="flex-shrink-0 mt-0.5">
                  <svg
                    class="w-5 h-5 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    ></path>
                  </svg>
                </div>
                <div class="min-w-0 flex-1">
                  <p class="text-xs text-gray-500 dark:text-gray-400">
                    Etapa del Negocio
                  </p>
                  <p class="text-sm font-medium text-gray-900 dark:text-white">
                    {{ getCycleName() }}
                  </p>
                </div>
              </div>

              <!-- Expected Close Date -->
              @if (deal.closeDate) {
                <div class="flex items-start gap-3">
                  <div class="flex-shrink-0 mt-0.5">
                    <svg
                      class="w-5 h-5 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      ></path>
                    </svg>
                  </div>
                  <div class="min-w-0 flex-1">
                    <p class="text-xs text-gray-500 dark:text-gray-400">
                      Fecha de Cierre Esperada
                    </p>
                    <p
                      class="text-sm font-medium text-gray-900 dark:text-white"
                    >
                      {{ formatDateShort(deal.closeDate) }}
                    </p>
                  </div>
                </div>
              }

              <!-- Estimated Close Datetime (v1.26) -->
              @if (deal.datetimeEstimatedClose) {
                <div class="flex items-start gap-3">
                  <div class="flex-shrink-0 mt-0.5">
                    <svg
                      class="w-5 h-5 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                      ></path>
                    </svg>
                  </div>
                  <div class="min-w-0 flex-1">
                    <p class="text-xs text-gray-500 dark:text-gray-400">
                      Cierre Estimado
                    </p>
                    <p
                      class="text-sm font-medium text-gray-900 dark:text-white"
                    >
                      {{ formatDate(deal.datetimeEstimatedClose) }}
                    </p>
                  </div>
                </div>
              }

              <!-- Priority (v1.26) -->
              @if (deal.priorityName || deal.idDealPriority) {
                <div class="flex items-start gap-3">
                  <div class="flex-shrink-0 mt-0.5">
                    <svg
                      class="w-5 h-5 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M5 3l14 9-14 9V3z"
                      ></path>
                    </svg>
                  </div>
                  <div class="min-w-0 flex-1">
                    <p class="text-xs text-gray-500 dark:text-gray-400">
                      Prioridad
                    </p>
                    <div class="flex items-center gap-2 mt-0.5">
                      @if (getPriorityColor()) {
                        <span
                          class="inline-block w-3 h-3 rounded-full flex-shrink-0"
                          [style.background-color]="getPriorityColor()"
                        ></span>
                      }
                      <p
                        class="text-sm font-medium text-gray-900 dark:text-white"
                      >
                        {{ deal.priorityName || '' }}
                      </p>
                    </div>
                  </div>
                </div>
              }

              <!-- Business Type (v1.26) -->
              @if (getBusinessTypeName()) {
                <div class="flex items-start gap-3">
                  <div class="flex-shrink-0 mt-0.5">
                    <svg
                      class="w-5 h-5 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                      ></path>
                    </svg>
                  </div>
                  <div class="min-w-0 flex-1">
                    <p class="text-xs text-gray-500 dark:text-gray-400">
                      Tipo de Negocio
                    </p>
                    <p
                      class="text-sm font-medium text-gray-900 dark:text-white"
                    >
                      {{ getBusinessTypeName() }}
                    </p>
                  </div>
                </div>
              }

              <!-- Owner / Responsible (v1.26) -->
              @if (deal.userPropietyId) {
                <div class="flex items-start gap-3">
                  <div class="flex-shrink-0 mt-0.5">
                    <svg
                      class="w-5 h-5 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                      ></path>
                    </svg>
                  </div>
                  <div class="min-w-0 flex-1">
                    <!-- Mismo dato que la cabecera («Responsable:»): ambos pintan ownerUser.
                         La columna es int_id_user_propiety, pero el término de la interfaz
                         es «Responsable» en todos los módulos. -->
                    <p class="text-xs text-gray-500 dark:text-gray-400">
                      Responsable
                    </p>
                    @if (loadingOwner) {
                      <span class="text-xs text-gray-400">Cargando...</span>
                    } @else if (ownerUser) {
                      <p
                        class="text-sm font-medium text-gray-900 dark:text-white"
                      >
                        {{ ownerFullName }}
                      </p>
                      <p class="text-xs text-gray-500 dark:text-gray-400">
                        {{ ownerUser.mail }}
                      </p>
                    } @else {
                      <p
                        class="text-sm font-medium text-gray-900 dark:text-white"
                      >
                        —
                      </p>
                    }
                  </div>
                </div>
              }
            </div>
          </div>

          <!-- Contactos Asociados (Junction) Section -->
          <div class="pt-4 border-t border-gray-200 dark:border-gray-700">
            <h3
              class="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-3"
            >
              Contactos Asociados
            </h3>

            @if (loadingContacts) {
              <div
                class="flex items-center gap-2 text-gray-500 dark:text-gray-400"
              >
                <div
                  class="animate-spin rounded-full h-4 w-4 border-b-2 border-brand-500"
                ></div>
                <span class="text-sm">Cargando contactos...</span>
              </div>
            } @else if (contactsError) {
              <div
                class="flex items-center gap-2 text-error-600 dark:text-error-400"
              >
                <svg
                  class="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  ></path>
                </svg>
                <span class="text-sm">{{ contactsError }}</span>
              </div>
            } @else if (dealContacts.length === 0) {
              <p class="text-sm text-gray-400 dark:text-gray-500">
                Sin contactos asociados
              </p>
            } @else {
              <div class="space-y-3">
                @for (dc of dealContacts; track dc.id) {
                  <div
                    class="flex items-start gap-3 p-3 rounded-lg bg-gray-50 dark:bg-gray-800/50"
                  >
                    <!-- Avatar -->
                    <div
                      class="flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center text-white text-sm font-semibold"
                      [ngClass]="getContactAvatarColor(dc)"
                    >
                      {{ getContactInitials(dc) }}
                    </div>

                    <!-- Info -->
                    <div class="flex-1 min-w-0">
                      <div class="flex items-center gap-2 flex-wrap">
                        <span
                          class="text-sm font-medium text-gray-900 dark:text-white"
                        >
                          {{ dc.contactFullname }}
                          {{ dc.contactLastname || '' }}
                        </span>
                        @if (dc.isPrimary) {
                          <span
                            class="inline-flex items-center px-2 py-0.5 text-xs font-semibold rounded bg-success-100 text-success-700 dark:bg-success-500/20 dark:text-success-400"
                          >
                            Principal
                          </span>
                        }
                        @if (dc.roleName) {
                          <span
                            class="inline-flex items-center px-2 py-0.5 text-xs font-medium rounded bg-brand-100 text-brand-700 dark:bg-brand-500/20 dark:text-brand-400"
                          >
                            {{ dc.roleName }}
                          </span>
                        }
                      </div>
                      <div class="flex flex-wrap gap-x-3 mt-0.5">
                        @if (dc.contactMail) {
                          <span
                            class="text-xs text-gray-500 dark:text-gray-400"
                            >{{ dc.contactMail }}</span
                          >
                        }
                        @if (dc.contactPhone) {
                          <span class="text-xs text-gray-500 dark:text-gray-400"
                            >· {{ dc.contactPhone }}</span
                          >
                        }
                      </div>
                      @if (dc.notes) {
                        <p
                          class="text-xs text-gray-400 dark:text-gray-500 italic mt-1"
                        >
                          {{ dc.notes }}
                        </p>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>

          <!-- Company Information -->
          <div class="pt-4 border-t border-gray-200 dark:border-gray-700">
            <h3
              class="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-3"
            >
              Empresa Asociada
            </h3>
            @if (loadingCompany) {
              <div
                class="flex items-center gap-2 text-gray-500 dark:text-gray-400"
              >
                <div
                  class="animate-spin rounded-full h-4 w-4 border-b-2 border-brand-500"
                ></div>
                <span class="text-sm">Cargando empresa...</span>
              </div>
            } @else if (company) {
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <!-- Company Commercial Name -->
                <div class="flex items-start gap-3">
                  <div class="flex-shrink-0 mt-0.5">
                    <svg
                      class="w-5 h-5 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                      ></path>
                    </svg>
                  </div>
                  <div class="min-w-0 flex-1">
                    <p class="text-xs text-gray-500 dark:text-gray-400">
                      Nombre Comercial
                    </p>
                    <p
                      class="text-sm font-medium text-gray-900 dark:text-white"
                    >
                      {{ company.commercialName }}
                    </p>
                  </div>
                </div>

                <!-- Company Business Name / Tax Code -->
                @if (company.businessName || company.taxCode) {
                  <div class="flex items-start gap-3">
                    <div class="flex-shrink-0 mt-0.5">
                      <svg
                        class="w-5 h-5 text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                        ></path>
                      </svg>
                    </div>
                    <div class="min-w-0 flex-1">
                      <p class="text-xs text-gray-500 dark:text-gray-400">
                        {{
                          company.taxCode
                            ? 'RUC / Razón Social'
                            : 'Razón
                Social'
                        }}
                      </p>
                      <p
                        class="text-sm font-medium text-gray-900 dark:text-white"
                      >
                        {{ company.businessName || company.taxCode || '—' }}
                        @if (company.businessName && company.taxCode) {
                          <span
                            class="text-xs text-gray-500 dark:text-gray-400"
                          >
                            - {{ company.taxCode }}</span
                          >
                        }
                      </p>
                    </div>
                  </div>
                }
              </div>
            } @else {
              <div
                class="flex items-center gap-2 text-gray-500 dark:text-gray-400"
              >
                <svg
                  class="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
                  ></path>
                </svg>
                <span class="text-sm">Sin empresa asociada</span>
              </div>
            }
          </div>

          <!-- Lead Vinculado -->
          @if (deal && deal.idLead) {
            <div class="pt-4 border-t border-gray-200 dark:border-gray-700">
              <h3
                class="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-3"
              >
                Lead Vinculado
              </h3>
              @if (loadingLead) {
                <div
                  class="flex items-center gap-2 text-gray-500 dark:text-gray-400"
                >
                  <div
                    class="animate-spin rounded-full h-4 w-4 border-b-2 border-brand-500"
                  ></div>
                  <span class="text-sm">Cargando lead...</span>
                </div>
              } @else if (lead) {
                <div class="flex items-start gap-3">
                  <div class="flex-shrink-0 mt-0.5">
                    <svg
                      class="w-5 h-5 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                      ></path>
                    </svg>
                  </div>
                  <div class="min-w-0 flex-1">
                    <p class="text-xs text-gray-500 dark:text-gray-400">
                      Nombre del Lead
                    </p>
                    <p
                      class="text-sm font-medium text-gray-900 dark:text-white"
                    >
                      {{ lead.name }}
                    </p>
                  </div>
                </div>
              } @else {
                <p class="text-sm text-gray-500 dark:text-gray-400" [title]="'Identificador interno del lead: ' + deal.idLead">
                  No se pudo cargar la información del lead vinculado.
                </p>
              }
            </div>
          }

          <!-- Closure Information (if closed) -->
          @if (isClosed) {
            <div class="pt-4 border-t border-gray-200 dark:border-gray-700">
              <h3
                class="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-3"
              >
                Información de Cierre
              </h3>
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <!-- Closed Date -->
                <div class="flex items-start gap-3">
                  <div class="flex-shrink-0 mt-0.5">
                    <svg
                      class="w-5 h-5 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      ></path>
                    </svg>
                  </div>
                  <div class="min-w-0 flex-1">
                    <p class="text-xs text-gray-500 dark:text-gray-400">
                      Fecha de Cierre
                    </p>
                    <p
                      class="text-sm font-medium text-gray-900 dark:text-white"
                    >
                      {{ formatDate(deal.datetimeClosed) }}
                    </p>
                  </div>
                </div>

                <!-- Close Description -->
                @if (deal.descriptionForClose) {
                  <div class="flex items-start gap-3 sm:col-span-2">
                    <div class="flex-shrink-0 mt-0.5">
                      <svg
                        class="w-5 h-5 text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                        ></path>
                      </svg>
                    </div>
                    <div class="min-w-0 flex-1">
                      <p class="text-xs text-gray-500 dark:text-gray-400">
                        Descripción de Cierre
                      </p>
                      <p
                        class="text-sm font-medium text-gray-900 dark:text-white"
                      >
                        {{ deal.descriptionForClose }}
                      </p>
                    </div>
                  </div>
                }
              </div>
            </div>
          }

          <!-- Timestamps Section -->
          <div class="pt-4 border-t border-gray-200 dark:border-gray-700">
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <!-- Created Date -->
              <div class="flex items-start gap-3">
                <div class="flex-shrink-0 mt-0.5">
                  <svg
                    class="w-5 h-5 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                    ></path>
                  </svg>
                </div>
                <div class="min-w-0 flex-1">
                  <p class="text-xs text-gray-500 dark:text-gray-400">
                    Fecha de Creación
                  </p>
                  <p class="text-sm font-medium text-gray-900 dark:text-white">
                    {{ formatDate(deal.datetimeCreated) }}
                  </p>
                </div>
              </div>

              <!-- Updated Date -->
              <div class="flex items-start gap-3">
                <div class="flex-shrink-0 mt-0.5">
                  <svg
                    class="w-5 h-5 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                    ></path>
                  </svg>
                </div>
                <div class="min-w-0 flex-1">
                  <p class="text-xs text-gray-500 dark:text-gray-400">
                    Última Actualización
                  </p>
                  <p class="text-sm font-medium text-gray-900 dark:text-white">
                    {{ formatDate(deal.datetimeUpdated) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      <!-- end info tab -->

      <!-- ========== TAB: COTIZACIONES ========== -->
      @if (activeTab === 'quotes') {
        <div>
          <!-- Encabezado de la sección con acción (solo cuando ya hay cotizaciones) -->
          @if (!loadingQuotes && !quotesError && dealQuotes.length > 0) {
            <div class="flex items-center justify-between mb-4">
              <h3 class="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">
                Cotizaciones del negocio
              </h3>
              <button
                type="button"
                (click)="nuevaCotizacion()"
                class="inline-flex items-center gap-1.5 rounded-lg bg-brand-500 px-3 py-2 text-sm font-medium text-white hover:bg-brand-600 transition-colors"
              >
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                </svg>
                Nueva cotización
              </button>
            </div>
          }

          @if (loadingQuotes) {
            <div class="flex items-center gap-2 text-gray-500 dark:text-gray-400 py-6">
              <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-brand-500"></div>
              <span class="text-sm">Cargando cotizaciones...</span>
            </div>
          } @else if (quotesError) {
            <div class="flex items-center gap-2 text-error-600 dark:text-error-400 py-6">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span class="text-sm">{{ quotesError }}</span>
            </div>
          } @else if (dealQuotes.length === 0) {
            <!-- Estado vacío resaltado: CTA prominente para crear la primera cotización -->
            <div class="flex flex-col items-center justify-center text-center rounded-xl border-2 border-dashed border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/40 px-6 py-10">
              <div class="flex items-center justify-center w-12 h-12 rounded-full bg-brand-100 dark:bg-brand-500/20 mb-4">
                <svg class="w-6 h-6 text-brand-600 dark:text-brand-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <p class="text-base font-semibold text-gray-900 dark:text-white">
                Este negocio aún no tiene cotizaciones
              </p>
              <p class="mt-1 text-sm text-gray-500 dark:text-gray-400 max-w-sm">
                Crea la primera cotización para este negocio. Se precargará con su contacto principal.
              </p>
              <button
                type="button"
                (click)="nuevaCotizacion()"
                class="mt-5 inline-flex items-center gap-2 rounded-lg bg-brand-500 px-5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-brand-600 transition-colors"
              >
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                </svg>
                Nueva cotización
              </button>
            </div>
          } @else {
            <div class="space-y-2">
              @for (quote of dealQuotes; track quote.id) {
                <button
                  type="button"
                  (click)="abrirCotizacion(quote)"
                  class="w-full flex items-center justify-between gap-3 p-3 rounded-lg bg-gray-50 dark:bg-gray-800/50 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors text-left"
                >
                  <div class="min-w-0">
                    <div class="flex items-center gap-2 flex-wrap">
                      <span class="text-sm font-medium text-gray-900 dark:text-white truncate">
                        {{ quote.quoteNumber }}
                      </span>
                      @if (quote.version) {
                        <span class="px-1.5 py-0.5 text-[10px] font-semibold rounded bg-brand-50 text-brand-700 dark:bg-brand-900/30 dark:text-brand-400">
                          v{{ quote.version }}
                        </span>
                      }
                      @if (quote.statusName) {
                        <span class="inline-flex items-center px-2 py-0.5 text-xs font-medium rounded bg-gray-200 text-gray-700 dark:bg-gray-700 dark:text-gray-300">
                          {{ quote.statusName }}
                        </span>
                      }
                    </div>
                    @if (quote.datetimeIssued || quote.datetimeCreated) {
                      <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                        {{ formatDateShort(quote.datetimeIssued || quote.datetimeCreated) }}
                      </p>
                    }
                  </div>
                  <span class="shrink-0 text-sm font-semibold text-brand-600 dark:text-brand-400">
                    {{ formatQuoteAmount(quote) }}
                  </span>
                </button>
              }
            </div>
          }
        </div>
      }
      <!-- end quotes tab -->

      <!-- ========== TAB: TIMELINE ========== -->
      @if (activeTab === 'timeline') {
        <app-audit-timeline
          [logs]="timelineLogs"
          [loading]="loadingTimeline"
          [error]="timelineError"
          [currentPage]="timelinePage"
          [totalPages]="timelineTotalPages"
          [totalElements]="timelineTotalElements"
          emptyMessage="No hay eventos de auditoría para este negocio."
          (pageChange)="loadTimeline($event)"
        />
      }
      <!-- end timeline tab -->

      @if (activeTab === 'automatizaciones' && deal.id) {
        <app-workflow-record-history
          objectType="DEAL"
          [objectId]="deal.id" />
      }
      <!-- end automatizaciones tab -->
    </div>
  }
</app-modal>
